import { AppGlobalActions } from '@app/_store/actions/global.actions';
import { UnloadedContainer } from '@core/models/general-types/general-types';
import { Pace } from '@core/models/interfaces/storage-data/pace';
import { createFeature, createReducer, on } from '@ngrx/store';

import { PaceActions, PaceInfoView } from './pace.actions';

export interface PaceState extends UnloadedContainer<Pace> {
  /** Which info panel the Plan side drawer shows; null — drawer closed. */
  infoView: PaceInfoView | null;
  /** 1-based day the details drawer shows; null — drawer closed. */
  detailsDay: number | null;
}

export const initialPaceState: PaceState = {
  object: null,
  metaData: null,
  infoView: null,
  detailsDay: null,
};

const paceReducer = createReducer(
  initialPaceState,
  on(AppGlobalActions.loadAppDataSuccess, (state, { globalState }) =>
    // R37. `...(globalState.pace ?? {})` would produce a new state object even
    // when this container is not part of the response, handing every consumer
    // a new reference and nothing else.
    globalState.pace ? { ...state, ...globalState.pace } : state
  ),
  on(PaceActions.showPaceInfo, (state, { view }) => ({
    ...state,
    infoView: view,
  })),
  on(PaceActions.showPaceDetails, (state, { day }) => ({
    ...state,
    detailsDay: day,
  }))
);

export const paceFeature = createFeature({
  name: 'pace',
  reducer: paceReducer,
  extraSelectors: ({ selectPaceState }) => ({
    selectPaceState,
  }),
});
